import { StyleSheet, Platform, Dimensions } from 'react-native'
import * as colors from '../../config/colors'
import * as variables from '../../config/variables'

const { width, height } = Dimensions.get('window')

const isLargerDevice = height > 600

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    // flex: 1,
    // borderWidth: 3,
    // borderColor: 'red'
  },
  logo: {
    // marginTop: 50,
    marginBottom: isLargerDevice ? 70 : 30,
  },
  sliderWrap: {
    // borderWidth: 3,
    // borderColor: 'red',
    // zIndex: 100,
    // flex: 1,
    // alignSelf: 'stretch',
    // width: '100%',
    // height: null,
    // position: 'absolute',
    // bottom: 0,
    // left: 0,
    // right: 0,
  },
  sliderWrapAndroid: {
    width,
  },
  slide: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'flex-start', // center
    paddingHorizontal: variables.SPACE_MD,
    paddingBottom: 60,
  },
  slideInner: {
    alignItems: 'center',
    maxWidth: 500,
  },
  dotStyle: {},
  dotActiveStyle: {
    backgroundColor: colors.black,
  },
  textHeadline: {
    // fontSize: variables.FONT_SIZE_MEDIUM,
    fontSize: isLargerDevice
      ? variables.FONT_SIZE_MEDIUM
      : variables.FONT_SIZE_BASE,
    fontWeight: 'bold',
    fontFamily: variables.FONT_FAMILY_BOLD,
    marginTop: variables.SPACE_MD,
    marginBottom: variables.SPACE_MD,
  },
  textHeadlineWithNoMargin: {
    marginTop: 0,
    marginBottom: 0,
    fontWeight: 'normal',
  },
  text: {
    textAlign: 'center',
    color: colors.grayDark,
    fontSize: isLargerDevice
      ? variables.FONT_SIZE_BASE
      : variables.FONT_SIZE_SMALL,
  },
  actionText: {
    fontSize: variables.FONT_SIZE_BASE,
    marginTop: variables.SPACE_LG,
    marginBottom: variables.SPACE_MD,
  },
})

export default styles
